import apiClient from '@/lib/apiClient';
import type { ApiResponse } from '@/lib/apiClient';
import type { AccountSearch } from './types';

export async function searchAccounts(searchText: string): Promise<AccountSearch[]> {
  const { data } = await apiClient.get<ApiResponse<AccountSearch[]>>(
    `/api/accounts/search/${encodeURIComponent(searchText)}`
  );
  if (!data.success) return [];
  return data.response ?? [];
}
